import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);

const DARK = "dark";
const LIGHT = "light";

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("ledger-theme") || LIGHT;
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("ledger-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === DARK ? LIGHT : DARK);
  const applyTheme  = (t) => setTheme(t === DARK ? DARK : LIGHT);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, applyTheme, isDark: theme === DARK }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
